import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from "@sentry/angular";
// Use Sentry.BrowserTracing and Sentry.routingInstrumentation from @sentry/angular for Angular v11
import { CommonModule } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutComponent } from './layout/layout.component';
import { HeaderComponent } from './includes/header/header.component';
import { FooterComponent } from './includes/footer/footer.component';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";

// Sentry.init should be called in main.ts before Angular bootstrap


import { SharedModule } from './shared/shared.module'; // import the SharedModule

import {FacebookLoginProvider, GoogleLoginProvider, SocialAuthServiceConfig, SocialLoginModule} from 'angularx-social-login';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private toastr: ToastrService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // Completely skip intercepting vendor-request endpoints
    if (req.url.includes('vendor-request')) {
      return next.handle(req);
    }
    
    return next.handle(req).pipe(
      catchError((error) => {
        // Only handle actual HTTP errors with non-200 status codes
        if (error instanceof HttpErrorResponse && error.status !== 200) {
          // Don't show error toast for vendor-request URLs or order get endpoints (expected during checkout)
          const isOrderGetRequest = error.url && error.url.includes('order/') && error.url.includes('/get');
          const isVendorRequest = !error.url || error.url.includes('vendor-request');
          
          if (!isVendorRequest && !isOrderGetRequest) {
            if (error.error && error.error.message) {
              this.toastr.error(error.error.message);
            }
          }
        }
        return throwError(error);
      })
    );
  }
}

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    HeaderComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    RouterModule,
    NgbModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    SlickCarouselModule,
    SharedModule, // add SharedModule here
    CommonModule,
    SocialLoginModule,
    GooglePlaceModule,

  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler() },
    { provide: Sentry.TraceService, deps: [Router] },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
